<template>
  <div
    ref="TmyChart"
    id="myTrendChart"
    :style="{ width: '100%', height: '100%' }"
  ></div>
</template>

<script>
import halloween from "../../../static/halloween";
import maxInputMixin from "../../mixins/maxInputMixin";
import commonMixin from "../../mixins/commonMixin";
import toolboxMixin from "../../mixins/toolboxMixin";
import { changeGraphData } from "@/components/ComUtils/ChangeGraphData";
import toolboxTrendGraphMixin from "../../mixins/toolboxTrendGraphMixin";
import graphicMixin from "../../mixins/graphicMixin";
import brushMixin from "../../mixins/brushMixin";
import keyPressSlotMixin from "@/mixins/keyPressSlotMixin";
import keepAliveMixin from "@/mixins/keepAliveMixin";
import offsetsMixin from "../../mixins/offsetsMixin";
import wavePointMixin from "../../mixins/wavePointMixin";
import {
  timestampToTimeFormat,
  timestampToTimeFormatLineBreaks,
  timestampToTimeFormatLineBreaksNoMilliseconds,
  timeStringToTimestamp
} from "../../components/ComUtils/TimeFormat";
import reDataZoomMixin from "../../mixins/reDataZoomMixin";
import {numberUtilsMixin} from "../../mixins/numberUtilsMixin";
import EventComparisonMixin from "../../mixins/EventComparisonMixin";


var elementResizeDetectorMaker = require("element-resize-detector");

export default {
  name: "AlarmTrendGraph",
  props: ['tongDao', "nowtimeStatic", "AlarmValueY",'requestData'],
  mixins: [maxInputMixin, commonMixin, toolboxMixin, toolboxTrendGraphMixin, graphicMixin, brushMixin, keyPressSlotMixin, keepAliveMixin,reDataZoomMixin,numberUtilsMixin, offsetsMixin,EventComparisonMixin, wavePointMixin],
  data() {
    return {
      tongDaoType: '0',
      status: '',
      Title: '',
      mychart: null,
      typename: '趋势图',
      arrx: [],
      arry: [],
      offset: '',
      mainCursor: '',//主游标值
      auxiliaryCursor: '',//辅游标值
      legendData: [],//保存图例名称
      nowStatic: true,
      proLine: null, // 上一条线标记
      refineFlag: false,
      changeBigFlag: false,
      AlarmValueData: [],
      positionMap: ['insideEndTop', 'insideEndBottom', 'insideEndTop', 'insideEndBottom'],
      isFull: false,
      isReal: "real",
      nowOption: null,
      allseries: [],
      aline: [],
      iconName: this.translateText("textMap.",'全屏'),
      myIcon: "M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M7.48,6.51l2.81-2.67\n" +
        "\t M10.79,6.09V3.62c0-0.22-0.18-0.39-0.39-0.39h-2.6 M6.68,7.36L3.84,10 M3.37,7.74l-0.03,2.47c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03",
      // myIcon:
      //   'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M7.48,6.51l2.81-2.67\n' +
      //   '\t M10.79,6.09V3.62c0-0.22-0.18-0.39-0.39-0.39h-2.6 M6.68,7.36L3.84,10 M3.37,7.74l-0.03,2.47c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03',
      maxXInputMixin: {
        // 关闭x轴修改最大值的input框
        show: false,
      },
      isMouseInChart: false,
    };
  },
  computed: {
    topiccolor() {
      return this.$store.state.topiccolor;
    },
    myicon() {
      return this.isFull;
    },
  },
  watch: {
    tongDao(value){
      this.tongDaoType = value
      this.aline = []
    },
    nowtimeStatic(data) {
      if(!this.activatedFlag) return ;
      this.nowStatic = data;
    },
    AlarmValueY(data) {
      if(!this.activatedFlag) return ;
      console.log('接收到的报警数据', data);
      this.AlarmValueData = data;
    },
    isFull(data) {
      if(!this.activatedFlag) return ;
      let mytop, mybottom;
      if (this.isReal == "history") {
        let tmpFullScreenName, tmpicon;
        if (this.isFull) {
          tmpFullScreenName = "退出全屏";
          this.iconName = tmpFullScreenName;
          tmpicon = 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M3.3,10.7l2.8-2.7\n' +
            '\t M6.6,10.3V7.8c0-0.2-0.2-0.4-0.4-0.4H3.6 M7.9,6l2.9-2.6 M7.5,3.8l0,2.5c0,0.2,0.2,0.4,0.4,0.4l2.6,0';
          this.myIcon = tmpicon;
        } else {
          // console.log('ok')
          tmpFullScreenName = "全屏";
          this.iconName = tmpFullScreenName;
          tmpicon =
            'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M7.48,6.51l2.81-2.67\n' +
            '\t M10.79,6.09V3.62c0-0.22-0.18-0.39-0.39-0.39h-2.6 M6.68,7.36L3.84,10 M3.37,7.74l-0.03,2.47c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03';
          // tmpicon =
          //   'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M3.29,10.73L6.1,8.06\n' +
          //   '\t M6.59,10.31V7.84c0-0.22-0.18-0.39-0.39-0.39h-2.6 M7.95,6.03L10.8,3.4 M7.49,3.78L7.46,6.25c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03';
          this.myIcon = tmpicon;
          // this.nowOption['toolbox']['feature']['myCancel']['title'] ='全屏';
          // this.nowOption['toolbox']['feature']['myCancel']['icon'] =  "M19.2,179.9,8,30.5A17.93,17.93,0,0,1,24.6,11.3a10.45,10.45,0,0,1,2.5,0L176.5,21.4m-163-3.5L216.4,218.3M577,179.1,588.2,29.7a18.08,18.08,0,0,0-16.6-19.3,10.45,10.45,0,0,0-2.5,0l-149.4,10m162-4.4L379.8,217.3M19.2,419.7,8,569.1a18.08,18.08,0,0,0,16.6,19.3,10.45,10.45,0,0,0,2.5,0l149.4-10.1m-163,3.5L216.4,381.4M419.6,579.2l149.4,10a18.09,18.09,0,0,0,19.2-16.8,10.45,10.45,0,0,0,0-2.5L577,420.6m4.8,163.1-202-201.4";
          // this.$set(this.iconPath, "path://M512.015052 32.633132c-264.662531 0-479.24645 214.629075-479.24645 479.366868s214.568867 479.38192 479.24645 479.38192c264.647479 0 479.231398-214.644128 479.231398-479.38192S776.662531 32.633132 512.015052 32.633132zM512.015052 931.474232c-231.231633 0-419.338762-188.197442-419.338762-419.45918 0-231.27679 188.107129-419.444128 419.338762-419.444128S931.338762 280.72321 931.338762 512.015052C931.338762 743.27679 743.14132 931.474232 512.015052 931.474232zM721.90269 321.334c-19.357107-12.68899-45.322123-7.255152-58.011113 12.177216L461.635396 642.607791l-96.695223-89.530384c-16.993914-15.669322-43.545965-14.660826-59.290548 2.333088-15.759635 17.054123-14.675878 43.561017 2.333088 59.275496l133.633279 123.668734 1.565427 0.978392 3.130854 3.221167 5.764986 2.227723 6.8939 2.799706 6.999265 1.068705 10.054858-0.120417 4.079142-0.948288 11.755755-4.891959 1.836366-1.369749 7.194943-5.193003 3.371689-5.509099 0.165574-0.255887L734.034749 379.46553C746.693635 360.033162 741.259797 334.02299 721.90269 321.334z")
        }
        let option = {
          toolbox: {
            feature: {
              myCancel: {
                icon: tmpicon,
                title: this.myicon ? this.translateText("textMap.",'退出全屏') : this.translateText("textMap.",'全屏'),
              },
            },
          },
        };
        this.mychart.setOption(option);
      }
    },
    myicon(val) {
      if (val == true) {
        this.FullScreenName = this.translateText("textMap.",'退出全屏')
        this.icon = 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M3.3,10.7l2.8-2.7\n' +
          '\t M6.6,10.3V7.8c0-0.2-0.2-0.4-0.4-0.4H3.6 M7.9,6l2.9-2.6 M7.5,3.8l0,2.5c0,0.2,0.2,0.4,0.4,0.4l2.6,0';
        // this.icon =
        //   'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M3.29,10.73L6.1,8.06\n' +
        //   '\t M6.59,10.31V7.84c0-0.22-0.18-0.39-0.39-0.39h-2.6 M7.95,6.03L10.8,3.4 M7.49,3.78L7.46,6.25c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03';
        //"M393,48.24,381.73,197.59a18,18,0,0,0,16.61,19.29,17.8,17.8,0,0,0,2.53,0l149.44-10m-162.08,4.42L590.16,10M207,549.69l11.17-149.37a18,18,0,0,0-16.63-19.27,17.52,17.52,0,0,0-2.51,0L49.59,391.16m163.12-3.52L9.84,588";
      } else {
        this.FullScreenName = this.translateText("textMap.",'全屏')
        this.icon =
          'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M7.48,6.51l2.81-2.67\n' +
          '\t M10.79,6.09V3.62c0-0.22-0.18-0.39-0.39-0.39h-2.6 M6.68,7.36L3.84,10 M3.37,7.74l-0.03,2.47c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03';
        // this.icon =
        //   'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M7.48,6.51l2.81-2.67\n' +
        //   '\t M10.79,6.09V3.62c0-0.22-0.18-0.39-0.39-0.39h-2.6 M6.68,7.36L3.84,10 M3.37,7.74l-0.03,2.47c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03';
        //"M19.2,179.9,8,30.5A17.93,17.93,0,0,1,24.6,11.3a10.45,10.45,0,0,1,2.5,0L176.5,21.4m-163-3.5L216.4,218.3M577,179.1,588.2,29.7a18.08,18.08,0,0,0-16.6-19.3,10.45,10.45,0,0,0-2.5,0l-149.4,10m162-4.4L379.8,217.3M19.2,419.7,8,569.1a18.08,18.08,0,0,0,16.6,19.3,10.45,10.45,0,0,0,2.5,0l149.4-10.1m-163,3.5L216.4,381.4M419.6,579.2l149.4,10a18.09,18.09,0,0,0,19.2-16.8,10.45,10.45,0,0,0,0-2.5L577,420.6m4.8,163.1-202-201.4";
      }

      var option = {
        toolbox: {
          feature: {
            myCancel: {
              icon: this.icon,
              title: this.FullScreenName,
            },
          },
        },
      };
      this.mychart.setOption(option);
    },
  },
  mounted() {
    this.$refs.TmyChart.style.setProperty('--textcolor', this.$store.state.textcolor);
    this.$refs.TmyChart.style.setProperty('--bgcolor', this.$store.state.bgcolor);
    this.$refs.TmyChart.style.setProperty('--tablecolor', this.$store.state.tablecolor);
    this.$refs.TmyChart.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
    this.$refs.TmyChart.style.setProperty('--buttontextcolor', this.$store.state.buttontextcolor);
    this.$refs.TmyChart.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
    this.$refs.TmyChart.style.setProperty('--defaultButtonColor', this.$store.state.defaultButtonColor);
    this.$nextTick(() => {

      this.drawchart();
    });

    const resizeObeserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const cr = entry.contentRect;
        this.$nextTick(() => {
          if(entry.contentRect.height != 0 && entry.contentRect.width != 0){ //被隐藏时，不再resize(),避免显示时出现堆叠问题
            this.mychart.resize();
            this.resizeMaxInput()
            this.updateMarkPoint()
            this.mychart.setOption({
              title: [
                {
                  id: 'Auxiliary-Cursor',
                  left: this.mychart.getWidth() * parseFloat(this.$store.state.grid.left) / 100 + 300,
                  top: "32px",
                  textStyle:{
                    fontSize: 10,
                    color: this.$store.state.primarySecondaryColor[1],
                  }
                }
              ],
            })
          }
        })
      }
    });


    resizeObeserver.observe(this.$refs.TmyChart);
  },
  methods: {
    formatTimestamp(ts) {
      return timestampToTimeFormat(ts);
    },

    setIsFull(data) {
      this.isFull = data;
    },
    drawchart() {
      let that = this;
      if (that.mychart) {
        that.mychart.clear();
        that.arrx = [];
        that.arry = [];
      } else {
        that.echarts.registerTheme("halloween", halloween);
        that.mychart = that.echarts.init(that.$refs.TmyChart, "halloween");
      }
      var defaultoption =  {
        backgroundColor: this.$store.state.leftconbgcolor,
        grid: {
          left: this.$store.state.grid.left,
          right: this.$store.state.grid.right,
          top: this.$store.state.grid.top,
          bottom: this.$store.state.grid.trendBottom,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          icon: "circle",
          y: "bottom",
          x: "center",
          itemWidth: 9,
          itemHeight: 9,
          textStyle: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.topiccolor == 'blue' ? this.$store.state.blueAxisLableColor : this.$store.state.textcolor,
          },
        },
        xAxis: {
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            color: this.$store.state.selectbordercolor,
            // color: this.$store.state.textcolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: "rgba(255,255,255,0.3)",
            },
          },
          type: "category",
        },
        yAxis: {
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: "value",
          splitNumber: 3, //y轴5个刻度
        },
      };
      // console.log('default start')
      that.mychart.setOption(defaultoption);
      // console.log('default ok')
    },
    clearall() {
      let that = this;
      if (that.mychart) {
        that.mychart.clear();

      }else{
        return
      }
      var defaultoption = {
        backgroundColor: this.$store.state.leftconbgcolor,
        grid: {
          left: this.$store.state.grid.left,
          right: this.$store.state.grid.right,
          top: this.$store.state.grid.top,
          bottom: this.$store.state.grid.trendBottom,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          icon: "circle",
          y: "bottom",
          x: "center",
          itemWidth: 9,
          itemHeight: 9,
          textStyle: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.topiccolor == 'blue' ? this.$store.state.blueAxisLableColor : this.$store.state.textcolor,
          },
        },
        xAxis: {
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: "rgba(255,255,255,0.3)",
            },
          },
          type: "category",
        },
        yAxis: {
          boundaryGap: [0.2, 0.2],
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: "value",
          splitNumber: 3, //y轴5个刻度
          min: 0,
          max: 3,
        },
      };
      that.mychart.setOption(defaultoption);
    },

    async setchartdata(flagX, flagY, dataX, dataY, title, type, mpoint = []) {
      //flagX: 横轴名称单位, string
      //flagY: 纵轴名称单位， string
      //dataX : 横轴数据 ,  [] 每一项是数据
      //dataY: 纵轴数据 ,  [] 每一项是一个json
      //                       json 内容格式 {
      //                                 name:曲线名称,  string
      //                                 data:曲线数据， []
      //                                 color:曲线颜色， string eg: #*****
      //                             }
      this.saveGraphData(flagX, flagY, dataX, dataY, title, type, true);
      if (type != "real") {
        if (this.modelFlag) {
          let changeData = changeGraphData(dataX, dataY);
          dataX = changeData.dataX;
          dataY = changeData.dataY;
        }
        this.setHighLightPoint(dataX, dataY, mpoint);
      }
      let that = this;
      this.isReal = type;
      var myseries = [];
      this.legendData = []
      let myYmin = "", myYmax = "";
      for (var i = 0; i < dataY.length; ++i) {
        myseries.push({
          id: dataY[i].name,
          name: this.translateText('textMap.',dataY[i].name),
          data: dataY[i].data,
          type: "line",
          showSymbol: false,
          connectNulls: true,
          lineStyle: {
            color: this.$store.state.colorMap[i],
            width: 1,
          },

          markPoint: {
            name: "显示报警",
            symbolSize: 10,
            symbol: 'circle',
            data: this.AlarmValueData[i],
          },
        });
        //  tulicolor.push(dataY[i].color)
        this.legendData.push(dataY[i].name)
        this.arry.push(dataY[i].data);
        // console.log(legenddata);
        let model = this.modelFlag && type != 'real'
        for (let item in dataY[i].data) {
          if (myYmin === "") myYmin = model ? dataY[i].data[item][1] : dataY[i].data[item];
          else myYmin = Math.min(myYmin, model ? dataY[i].data[item][1] : dataY[i].data[item]);
          if (myYmax === "") myYmax = model ? dataY[i].data[item][1] : dataY[i].data[item];
          else myYmax = Math.max(myYmax, model ? dataY[i].data[item][1] : dataY[i].data[item]);
        }
      }
      if(this.alarmFlag && this.aline.length){
        let tempAlineY = this.aline.map(item => {
          return item.yAxis
        }).sort((a, b) => {
          return b - a
        })
        myYmax = Math.max(myYmax,tempAlineY[0])
        myYmin = Math.min(myYmin,tempAlineY[tempAlineY.length - 1])
      }
      if (type != "real") {
        var mytoolbox = {
          itemGap: 8,
          itemSize: 18,
          top: 8,
          right: 5,
          iconStyle: {
            normal: {
              borderColor: this.$store.state.toolboxcolor,
            },
            emphasis: {
              textPadding: this.$store.state.paddingtop,
              textFill: this.$store.state.toolboxtextcolor,
            },
          },
          feature: {
            ...this.getPrimarySecondary(),
            ...this.getMarkPoint(),
            ...this.custombrush(),
            ...this.getMyBrushRestore(),
            ...this.getMyUseNowTime(),
            ...this.getAlarmLine(),
            ...this.getMark(),
            ...this.getModel(),
            ...this.getMarkWavePoint(),
            // ...this.reDataZoomIn(),
            // ...this.reDataZoomOut(),
            mySaveChart: {
            show: this.shouldShowSaveChartButton(),
            title: this.translateText("textMap.",'设为基准数据'),
            icon: "M13.5,7c0,3.6-2.8,6.5-6.5,6.5c-3.6,0-6.5-2.8-6.5-6.5S3.4,0.5,7,0.5S13.5,3.5,13.5,7z M10.2,6.1V3.9c0-0.3-0.3-0.6-0.6-0.6h-5C4.3,3.3,4,3.6,4,3.9V10c0,0.3,0.3,0.6,0.6,0.6h1.8 M5.1,4.9h3.4 M5.1,6.6h3.4 M5.1,8.3h2.2 M11.2,6.4L7,11",
            onclick: () => {
              this.saveChartParameter()
              this.refreshSampleList()
            },
          },
            myCancel: {
              show: true,
              title: this.myicon ? this.translateText("textMap.",'退出全屏') : this.translateText("textMap.",'全屏'),
              // icon:"M19.2,179.9,8,30.5A17.93,17.93,0,0,1,24.6,11.3a10.45,10.45,0,0,1,2.5,0L176.5,21.4m-163-3.5L216.4,218.3M577,179.1,588.2,29.7a18.08,18.08,0,0,0-16.6-19.3,10.45,10.45,0,0,0-2.5,0l-149.4,10m162-4.4L379.8,217.3M19.2,419.7,8,569.1a18.08,18.08,0,0,0,16.6,19.3,10.45,10.45,0,0,0,2.5,0l149.4-10.1m-163,3.5L216.4,381.4M419.6,579.2l149.4,10a18.09,18.09,0,0,0,19.2-16.8,10.45,10.45,0,0,0,0-2.5L577,420.6m4.8,163.1-202-201.4",
              icon: this.myIcon,

              onclick: function () {
                that.$emit("cancelFull");
              },
            },
            saveAsImage: {
              title: this.translateText("textMap.",'导出'),
              icon: 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M6.3,6.1H4.7\n' +
                '\tL7,8.7l2.3-2.5H7.8l-0.1-3H6.2L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
              // icon: 'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M6.3,6.1H4.7L7,8.7\n' +
              //   '\tl2.3-2.5H7.8V3.5H6.3L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
              //icon: "M279,16.6V444.4M94.6,251.9,265.8,438.8a17.76,17.76,0,0,0,25.2,1.1,11.41,11.41,0,0,0,1.1-1.1L463.3,251.9M6.5,397.1V537.6a23.69,23.69,0,0,0,23.7,23.7H527.7a23.69,23.69,0,0,0,23.7-23.7h0V397.1",
              iconStyle: {
                emphasis: {
                  textPadding: [
                    this.$store.state.paddingtop,
                    this.$store.state.paddingright,
                  ],
                },
              },
            },
          },
        };
      } else {
        var mytoolbox = {
          itemGap: 8,
          itemSize: 18,
          top: 8,
          right: 5,
          iconStyle: {
            normal: {
              borderColor: this.$store.state.toolboxcolor,
            },
            emphasis: {
              textPadding: this.$store.state.paddingtop,
            },
          },
          feature: {
            ...this.getMarkPoint(),
            ...this.getAlarmLine(),
            saveAsImage: {
              title: this.translateText("textMap.", '导出'),
              icon: 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M6.3,6.1H4.7\n' +
                '\tL7,8.7l2.3-2.5H7.8l-0.1-3H6.2L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
              // icon: 'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M6.3,6.1H4.7L7,8.7\n' +
              //   '\tl2.3-2.5H7.8V3.5H6.3L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
              iconStyle: {
                emphasis: {
                  textPadding: [
                    this.$store.state.paddingtop,
                    this.$store.state.paddingright,
                  ],
                },
              },
            },
          },
        };
      }
      this.zoomState = false;
      that.arrx = dataX;
      let left , right
      if(this.$store.state.nowTrendStartTime && this.$store.state.nowTrendEndTime){
        left = this.$store.state.nowTrendStartTime
        right = this.$store.state.nowTrendEndTime
      }else{
        left = dataX[0]
        right = dataX[dataX.length - 1]
      }
      var option = {
        backgroundColor: this.$store.state.leftconbgcolor,
        grid: {
          left: this.$store.state.grid.left,
          right: this.$store.state.grid.right,
          top: this.$store.state.grid.top,
          bottom: this.$store.state.grid.trendBottom,
        },
        title: [
          {
            id: 'title',
            top: '12',
            left: "center",
            text: title,
            textStyle: {
              fontSize: 16, //大小
              color: this.$store.state.textcolor
            },
          },
          {
            id: 'offset',
            top: '13',
            left: this.$store.state.grid.left,
            text: "",
            textStyle: {
              fontSize: 10, //大小
              fontFamily: "Microsoft YaHei UI"
            },
          },
          {
            id: 'Main-Cursor',
            left: this.$store.state.grid.left,
            top: "32px",
            textStyle: {
              fontSize: 10,
              color: this.$store.state.primarySecondaryColor[0],
            }
          }, {
            id: 'Auxiliary-Cursor',
            left: this.mychart.getWidth() * parseFloat(this.$store.state.grid.left) / 100 + 300,
            top: "32px",
            textStyle:{
              fontSize: 10,
              color: this.$store.state.primarySecondaryColor[1],
            }
          }
        ],
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter:(params)=>{
            let list = []
            let listItem = ''
            //  console.log('提示框', params, this.modelFlag);
            if (this.modelFlag) {
              // console.log(params[0].axisValue);
              this.$store.state.tooltipTime = params[0].axisValue;
            }
            for (let i = 0; i < params.length; i++) {
                list.push(
                  this.modelFlag ?
                  '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
                  params[i].color + ';margin-right: 5px;border-radius: 50%;}"></i><span style="  display:inline-block;">' +
                  params[i].seriesName + ': ' +
                  '</span> ' + this.roundToDecimalPlaces(parseFloat(params[i].value[1]),3) + " " + flagY.replace(/^\[|\]$/g, '') :
                  '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
                  params[i].color + ';margin-right: 5px;border-radius: 50%;}"></i><span style="  display:inline-block;">' +
                  params[i].seriesName + ': ' +
                  '</span> ' + this.roundToDecimalPlaces(parseFloat(params[i].value),3) + " " + flagY.replace(/^\[|\]$/g, '')
                )

            }
            list.unshift(this.modelFlag ?
              timestampToTimeFormatLineBreaks(params[0].axisValue):
              params[0].axisValue);
            listItem = list.join('<br>')
            return '<div class="showBox">' + listItem + '</div>'
          }
        },
        dataZoom:[{
          type: "inside",         //详细配置可见echarts官网
          zoomLock: true,
          disabled: true, // 禁用内部的缩放功能
        }],
        toolbox: mytoolbox,
        color: this.$store.state.colorMap,
        brush: {
          xAxisIndex: "all",
          transformable: false,
          outOfBrush: {
            colorAlpha: 0.1,
          },
          throttleType: "debounce",
          throttleDelay: 2000,
        },
        legend: {
          type: 'scroll',
          pageIconColor: this.$store.state.selectbordercolor,
          pageIconInactiveColor: this.$store.state.selectbordercolor,
          pageTextStyle:{
            color: this.$store.state.selectbordercolor
          },
          left: 50,
          bottom: 6,
          data: this.legendData.map((name) => {
            return {
              name: this.translateText('textMap.',name),
              icon: 'rect',  // 使用矩形图标
            };
          }),
          itemWidth: 12,
          itemHeight: 6,
          itemGap: 24,  // 图例项之间的间距
          formatter: function (name) {
            return '{a|' + name + '}';
          },
          textStyle: {
            rich: {
              a: {
                verticalAlign: 'middle',  // 使图标垂直居中
                lineHeight: 12,  // 根据图标高度调整行高
                fontSize: 12,
                color: this.$store.state.selectbordercolor,
                padding: [0, 0, 3, 4],  // 调整文字和图标的间距
              }
            }
          }
        },

        xAxis: {
          axisLine: {
            onZero: false,
          },
          name: flagX == '[时间]' || this.flagX == '[Time]' ? this.translateText('textMap.', '趋势图时间单位') : flagX,
          nameTextStyle: {
            padding:[0,0,0,-14]
          },
          data: dataX,
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            // color: this.$store.state.textcolor,
            showMinLabel: true,
            showMaxLabel: true,
            padding: [0, 5, 0, 5],
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
            formatter: (value, index) => {
              // console.log(value);
              return  this.modelFlag ? timestampToTimeFormatLineBreaksNoMilliseconds(value) : value.replace(' ', '\n');
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: this.modelFlag ? "time" : "category",
          min: this.modelFlag ? left : dataX[0],
          max: this.modelFlag ? right : dataX[dataX.length - 1]
        },
        yAxis: {
          name: flagY,
          nameTextStyle: {
            padding:[0,45,-6,0]
          },
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            showMinLabel: true,
            showMaxLabel: true,
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          min: this.roundDown(myYmin, myYmax),
          max: this.roundUp(myYmin, myYmax),
          type: "value",
          splitNumber: 3, //y轴5个刻度
        },
        series: myseries,
        OriginalSeries: myseries,
        OriginalXAxisData: dataX,
        useDataZoomBegin :[new Date(dataX[0]).getTime()],
        useDataZoomEnd: [new Date(dataX[dataX.length - 1]).getTime()]
      };
      this.allseries = myseries;
      that.nowOption = option;
      that.mychart.setOption(option);
      this.resizeMaxInput();
      if (this.brushState) {
        that.mychart.dispatchAction({
          type: "takeGlobalCursor",
          key: "brush",
          brushOption: {
            brushType: "lineX",
          },
        });
      }
      if(this.alarmFlag){
        that.handleAlarm(this.alarmFlag)
      }
      this.mychart.off("brushEnd")
      this.mychart.on("brushEnd", (params) => {
        this.renderBrushed(params);
      })
      this.mychart.getZr().off("click");
      this.mychart.getZr().on("click", this.chartClick);
      if(this.nowFeature == 'one' || this.nowFeature == 'two' || this.nowFeature == 'three' || this.nowFeature == 'half' || this.nowFeature == 'phaseOne' || this.nowFeature == 'phaseTwo' || this.nowFeature == 'phaseThree' || this.nowFeature == 'phaseHalf') {
        this.mychart.getZr().on('contextmenu', this.contextMenu)
      }else{
        this.mychart.getZr().off('contextmenu', this.contextMenu)
      }
      this.mychart.off('dataZoom')
      this.mychart.on('dataZoom', (e) => {
        this.updateMarkPoint()
      });
      this.mychart.getZr().on('mousemove', this.mouseMoveEvent)
      this.mychart.getZr().on('globalout', this.globalOutEvent);
      this.updateAlarmPoint()
    },
    setchart(flagX, flagY, dataX, dataY, title, type, initialData, mpoint = []) {
      if(initialData){
        this.chartData = initialData.chartData;
        this.nowFeature = initialData.feature;
        this.requistData = initialData.requistData;
      }
      if(flagY === '[m/s2]') {
        flagY = '[m/s²]';
      }
      if(flagY === '[]') {//当y轴没有单位时，去掉[]
        flagY = '';
      }
      this.drawchart();
      this.offset = ''
      this.mainCursor = ''
      this.auxiliaryCursor =  ''
      this.status = type
      this.Title = title.indexOf('趋势图') == -1 && title.indexOf('trend') == -1 && title.indexOf('Trend') == -1 ? title + ' 趋势图' : title
      title = ''
      this.Title.trim().split(' ').forEach(item => title += this.translateText('textMap.', item)+' ')
      this.$nextTick(() => {
        // console.log(flagX, flagY, dataY, dataX);
        this.setchartdata(flagX, flagY, dataX, dataY, title, type, mpoint);
        this.setChartAfter();
        this.createDropdownMenu();
        console.log("aoifaoidoinf",this.mychart.getOption())
      });
    },
    updateAlarmPoint(){
      if(this.$store.state.pointId && this.$store.state.alarmEndTime){
        let xTime = new Date(this.$store.state.alarmEndTime).getTime()
        this.$store.state.alarmEndTime = ''
        let option = this.mychart.getOption()
        let xAxisData = option.xAxis[0].data
        // 将获取的时间，遍历成时间戳
        let xAxisDataTime = xAxisData.map(x => new Date(x).getTime())
        // 找到最接近的时间值
        xTime = this.findClosestValue(xTime, xAxisDataTime);
        let xIndex = xAxisDataTime.indexOf(xTime);
        let param = {};
        param.name = option.xAxis[0].data[xIndex];
        param.xIndex = xIndex
        param.seriesNameIndex = 0
        param.seriesName = option.series[0].name;
        param.seriesId = option.series[0].id;//seriesId的值用于往复-振动监测，点击趋势图后显示波形图，请求传参数
        param.seriesY = option.series[0].data[xIndex]
        param.isPrimaryCursor = this.PrimarySecondary.isMark !== undefined ? this.PrimarySecondary.isMark : true;
        if(this.status == undefined || this.status != 'real') {
          this.drawLineAndProLine(param.name, 0, param, null)
          // 告诉父组件刷新其它页面，父组件如果不执行这个函数，相当于没有影响
          this.$emit("chartinfo", param);
        }
      }
    },
    changechart(x, y) {
      //x 横轴新添数据
      // y 一个[] 纵轴每项新增的数据
      let that = this;
      if (that.arrx.length >= 50) {
        that.arrx.shift();
        for (var i = 0; i < that.arry.length; ++i) {
          that.arry[i].shift();
        }
      }
      var newseries = [];
      that.arrx.push(x);
      for (var i = 0; i < that.arry.length; ++i) {
        that.arry[i].push(y[i]);
        newseries.push({
          data: that.arry[i],
        });
      }
      var option = {
        xAxis: {
          data: this.arrx,
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
          },
        },
        yAxis: {
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
          },
        },
        series: newseries,
      };
      that.mychart.setOption(option);
    },
    renderBrushed(params) {
      this.delALLMarkPoint();
      let left, right;
      if (!this.modelFlag) {
        if (params.batch[0].areas.length == 0) {
        //没有选框
        return;
      }
      left = params.batch[0].areas[0]["coordRange"][0];
      right = params.batch[0].areas[0]["coordRange"][1];
      if (left < 0) {
        left = 0;
      }
      if (right >= this.arrx.length) {
        right = this.arrx.length - 1;
      }
      let tmpLeft = left;
      let tmpRight = right;
      left = this.arrx[left];
      if (!parseInt(left)) {
        let flag = true;
        for (let item = tmpLeft - 1; item >= 0; item--) {
          if (parseInt(this.arrx[item])) {
            left = this.arrx[item];
            tmpLeft = item;
            flag = false;
            break;
          }
        }
        if (flag) {
          for (let item = tmpLeft + 1; item < this.arrx.length; item++) {
            if (parseInt(this.arrx[item])) {
              left = this.arrx[item];
              tmpLeft = item;
              flag = false;
              break;
            }
          }
        }
      }
      right = this.arrx[right];
      if (!parseInt(right)) {
        let flag = true;
        for (let item = tmpRight + 1; item < this.arrx.length; item++) {
          if (parseInt(this.arrx[item])) {
            right = this.arrx[item];
            tmpRight = item;
            flag = false;
            break;
          }
        }
        if (flag) {
          for (let item = tmpRight - 1; item >= 0; item--) {
            if (parseInt(this.arrx[item])) {
              right = this.arrx[item];
              tmpRight = item;
              flag = false;
              break;
            }
          }
        }
      }
      if (tmpLeft > tmpRight) {
        left = this.arrx[tmpRight];
        right = this.arrx[tmpLeft];
      }
      } else {
        left = params.areas[0]["coordRange"][0];
        right = params.areas[0]["coordRange"][1];
      }
      let Data = this.mychart.getOption().series[0].data;
      let hasData = false;
      for(let i in Data){
        let t = timeStringToTimestamp(Data[i][0]);
        if (t<=right && t>=left){
          hasData = true;
          break;
        }
      }
      if(!hasData){
        this.$parent.$emit("brushdatanull")
        return;
      }
      this.$store.state.nowTrendStartTime = new Date(left).valueOf()
      this.$store.state.nowTrendEndTime = new Date(right).valueOf()
      this.refineFlag = true
      if(this.zoomState == true){
        // this.$store.state.useDataZoom = true
        this.$emit("dataZoom",new Date(left).valueOf(), new Date(right).valueOf());
      }else if (this.brushState){
        this.$emit("refine", new Date(left).valueOf(), new Date(right).valueOf());
      }
      this.mychart.dispatchAction({
        type: 'brush',
        areas: [] // 清除所有刷选区域
      })
    },
    saveChartParameter(){
      this.$store.state.showEventDialogFlag = true
      this.$store.state.postData = {
        equipmentUuid: this.requestData.equipmentUuid,
        // pointUuid: this.requestData.pointUuid,
        markTime: this.requestData.trendTime,
        feature: -1,
        amplitude: -1,
        phase: -1,
        name: "测试波形对比事件",
        isDefault: -1,
        datatype: -1,
        childType: -1,
        eventType: 2,
        offsetsRange: this.requestData.offsetsRange,
        info:{...this.requestData}
      }
    },
    // 手动触发样本列表刷新
    refreshSampleList() {
      this.$store.commit('toggleSampleRefreshFlag');
    },
  },
};
</script>

<style scoped>
#myTrendChart{
  --bgcolor: #fdfdfd;
  --tablecolor: #ffffff;
  --textcolor: #000000;
  --buttoncolor: #1677FF;
  --buttontextcolor: #ffffff;
  --conbgcolor: #0D0F1F;
  --defaultButtonColor: #1D8EFF;
  .selectListMenu{
    width: 240px;
    border: 1px solid #ccc;
    border-radius: 5px;
    z-index: 99999999;
    background-color: var(--bgcolor);
    color: var(--textcolor);

    .selectListMenuHeader{
      font-weight: bold;
      padding: 14px 20px 14px 20px;
      border-bottom: 0.5px solid #c0c4cc;
      font-size: 16px;
      line-height: 20px;
      .deleteMenuWrapper{
        height: 20px !important;
        width: 20px !important;
        fill: #ccc;
        cursor: pointer;
        position: absolute;
        top: 14px;
        right: 20px;
        width: 14px;
        height: 20px;
      }
      .deleteMenuWrapper:hover{
        background-color: #ff0000;
      }
    }

    .selectListMenuBody{
      .option{
        padding: 10px 20px 10px 20px;
      }
      .option:hover{
        background-color: var(--buttoncolor);
        color: var(--bgcolor);
      }
    }

    .selectListMenuBottom{
      border-top: 1px solid #c0c4cc;
      .option{
        padding: 10px 20px 10px 20px;
      }
      .option:hover{
        background-color: var(--buttoncolor);
        color: var(--bgcolor);
      }
    }
  }
  .createDataSetMenu{
    width: 1024px;
    border: 1px solid #ccc;
    border-radius: 5px;
    z-index: 99999999;
    font-size: 16px;
    line-height: 100%;
    background-color: var(--bgcolor);
    color: var(--textcolor);

    .createDataSetMenuHeader{
      padding: 20px 10px 14px 20px;
      align-items: center;
      font-weight: bold;
      .deleteMenuWrapper{
        height: 20px !important;
        width: 20px !important;
        fill: #ccc;
        cursor: pointer;
        position: absolute;
        top: 14px;
        right: 20px;
        width: 14px;
        height: 20px;
      }
      .deleteMenuWrapper:hover{
        background-color: #ff0000;
      }
    }

    .createDataSetMenuBody{
      padding-top: 20px;
      padding-bottom: 20px;
      border-top: 1px solid #ccc;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      align-items: center;
      .formItem{
        font-weight: bold;
        display: flex;
        padding: 20px 0px 0px 0px;
        margin-left: 20px;
        .title{
          width: 200px;        /* ✅ 统一 title 宽度 */
          text-align: right;   /* ✅ 文字右对齐 */
          margin-right: 12px;  /* ✅ 与输入区域的间距 */
          flex-shrink: 0;
        }
        .name{
          margin-left: 20px;
          padding-left: 10px;
          height: 30px;
          width: 300px;
          border: 0.5px solid #ccc;
          border-radius: 4px;
          box-sizing: border-box;
        }
        .default{
          margin-left: 20px;
        }
        .type{
          margin-left: 20px;
        }
        .optionConf{
          font-weight: normal;
          font-size: medium;
        }
        .childType{
          margin-left: 20px;
        }
        .range{
          margin-left: 20px;
        }

        .default {
          width: 46px;
          height: 22px;
          vertical-align: bottom; /* ✅ 跟文字等垂直居中对齐 */
          display: inline-block;  /* ✅ 避免换行和布局错乱 */
          box-sizing: border-box;
          position: relative;
          background: #cccccc;
          //border: 1px solid #dfdfdf;
          border-radius: 16px;
          line-height: 20.5px;
          text-align: center;
          cursor: pointer;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          outline: 0;
        }

        .default:active,
        .default:visited {
          outline: none;
        }

        .default:before {
          content: attr(data-off);
          position: absolute;
          top: 0;
          left: 1px;
          padding-left: 13px;
          border-radius: 15px;
          background-color: #cccccc;
          color: #fff;
          font-size: 12px;
        }

        .default:after {
          content: " ";
          position: absolute;
          top: 4px;
          left: 2px;
          width: 12px;
          height: 12px;
          border-radius: 15px;
          background-color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
          transition: transform 0.3s;
        }

        .default:checked {
          //border-color: #0c66ff;
          background-color: var(--buttoncolor);
        }

        .default:checked:after {
          transform: translateX(28px);
        }

        .default:checked:before {
          content: attr(data-on);
          padding-left: 0px;
          padding-left: 2px;
          background-color: var(--buttoncolor);
          color: #fff;
          width: 24px;
        }
      }
      #formItem4{
        //margin-left: 32px;
      }
      #formItem5{
        //margin-left: 16px;
      }
      .buttons{
        display: flex;
        justify-content: flex-end; /* 将按钮对齐到容器的右侧 */
        padding-right: 20px; /* 距离右侧20px */
        #createDataSetCancel{
          height: 24px;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-left: 10px; /* 与保存按钮之间的间距 */
          background-color: var(--bgcolor);
          color: var(--textcolor);
          transition: background-color 0.3s, color 0.3s; /* 平滑过渡效果 */
        }
        #createDataSetSave{
          //width: 42px;
          height: 24px;
          border: 1px solid #007bff;
          border-radius: 4px;
          background-color: var(--buttoncolor);
          color: var(--buttontextcolor);
          margin-left: 10px; /* 与取消按钮之间的间距 */
          transition: background-color 0.3s, color 0.3s; /* 平滑过渡效果 */
        }
      }
    }
  }
  .dataBaseListMenu{
    width: 1024px;
    border: 1px solid #ccc;
    border-radius: 5px;
    z-index: 99999999;
    font-size: 16px;
    line-height: 100%;
    background-color: var(--bgcolor);
    color: var(--textcolor);

    .dataBaseListMenuHeader{
      padding: 14px 20px 14px 20px;
      align-items: center;
      font-weight: bold;
      .deleteMenuWrapper{
        height: 20px !important;
        width: 20px !important;
        fill: #ccc;
        cursor: pointer;
        position: absolute;
        top: 14px;
        right: 20px;
        width: 14px;
        height: 20px;
      }
      .deleteMenuWrapper:hover{
        background-color: #ff0000;
      }
    }
    .dataBaseListMenuBody{
      padding-top: 20px;
      padding-bottom: 20px;
      border-top: 1px solid #ccc;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      align-items: center;
      .dataList{
        table {
          border-collapse: collapse;
          margin-bottom: 20px;
          margin-left: 20px;
        }

        th, td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }

        th {
          background-color: var(--conbgcolor);
          font-weight: bold;
        }

        .defaultBtn,
        .deleteBtn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 32px;         /* ✅ 设置固定高度 */
          padding: 0 8px;       /* ✅ 设置一致的内边距 */
          font-size: 14px;      /* ✅ 统一字体 */
          background: transparent;
          border: none;
          cursor: pointer;
          line-height: 1;
          vertical-align: middle;
          color: var(--textcolor);
        }


        .defaultBtn:hover:not(:disabled) {
          text-decoration: underline;  /* 可选，增加悬停效果 */
          color: var(--textcolor); /* hover 状态颜色 */
        }

        .defaultBtn:disabled {
          color: var(--defaultButtonColor) !important; /* hover 状态颜色 */
        }


        .deleteBtn:hover {
          color: #c0392b; /* hover 更深色 */
        }


        th input[type="checkbox"], td input[type="checkbox"] {
          margin: 0;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
        .pagination{
          margin: 0px 10px 10px 0px;
          button {
            margin: 0 3px;
            padding: 3px 6px;
            font-size: 14px;
            border: 1px solid #ccc;
            background-color: var(--bgcolor);
            color: var(--textcolcor);
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
          }

          button:hover {

          }

          button:disabled {
            cursor: not-allowed;
            border: 1px solid #ccc;
            background-color: var(--bgcolor);
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            color: var(--textcolcor);
          }

          button.active {
            background-color: #007bff;
            color: #fff;
            border-color: #007bff;
          }

        }
      }
      .buttons{
        display: flex;
        justify-content: flex-end; /* 将按钮对齐到容器的右侧 */
        padding-right: 20px; /* 距离右侧20px */
        #dataBaseListMenuCancel{
          //width: 42px;
          height: 24px;
          cursor: pointer;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-left: 10px; /* 与保存按钮之间的间距 */
          background-color: var(--bgcolor);
          color: var(--textcolor);
        }
        #dataBaseListMenuSave{
          height: 24px;
          cursor: pointer;
          border: 1px solid #007bff;
          border-radius: 4px;
          background-color: var(--buttoncolor);
          color: var(--buttontextcolor);
          margin-left: 10px; /* 与取消按钮之间的间距 */
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ComUtils/AlarmTrendGraph.vue